module.exports = __webpack_public_path__ + "static/media/tile-de-novo-assembly.03003614.svg";